import ButtonGroup from "../ButtonGroup";
import "./index.scss";

export default function Layout({ options, onChange, selected, className = "brandy-btn-group-icons" }) {
  return (
    <ButtonGroup
      options={options}
      onChange={onChange}
      selected={selected}
      className={className}
    />
  );
}